import { createContext, ReactNode, useContext, useState } from 'react';
import { TreeBenhAnNode } from '../types';

type ContextProps = {
	phieuBenhAn: TreeBenhAnNode;
	setPhieuBenhAn: (data: TreeBenhAnNode) => void;
};

type ContextProviderProps = {
	children: ReactNode;
};

const initialValue: TreeBenhAnNode = {
	id:'',
	termId: 0,
	code: '',
	name: '',
	displayCode: '',
	filter: [],
	sortWeight: 0,
	attributes: {
		isMultiple: '',
		docTemplate: '',
		templateType: '',
	},
};

const BenhAnContext = createContext<ContextProps>({
	phieuBenhAn: initialValue,
	setPhieuBenhAn: () => {},
});

export const BenhAnContextProvider = ({ children }: ContextProviderProps) => {
	const [phieuBenhAn, setPhieuBenhAn] = useState<TreeBenhAnNode>(initialValue);

	return (
		<BenhAnContext.Provider
			value={{
				phieuBenhAn,
				setPhieuBenhAn,
			}}
		>
			{children}
		</BenhAnContext.Provider>
	);
};

export const useBenhAnContext = () => useContext(BenhAnContext);
